import { initClickableArea, tabHighlight, tabHighlightRemove } from "./components/global_accessibility";
import { initMenu } from "./components/menu";
import { initMegaMenu } from "./components/megamenu";
import { initTopMenu } from "./components/top-menu";
import { initResponsiveMenu } from "./components/responsivemenu";
import { initSearch, initResponsiveSearch } from "./components/search";
import { coreCoverStyles, coreCoversplitResponsive } from "./components/core_blocks";
import visible from "../extras/visible/jquery.visible";
//import { setCookie, deleteCookie, dbyh_ajax_call, initLightbox } from "./components/global_functions";

export default {
	init() {
		// JavaScript to be fired on all pages

		// Accessibility: Handle tab highlighting
		//---------------------------------------------------------------------------
		$("body").on("keyup", "a, .btn, button, input, textarea, select, .clickable-area", function (e) {
			tabHighlight(e);
		});

		$("body").on("blur", ".tabbed", function (e) {
			tabHighlightRemove(e);
		});

		// Accessibility: Initiate Cickabel areas
		//---------------------------------------------------------------------------
		initClickableArea();

		// Toggle Attribute on all buttons with classname .expander
		//---------------------------------------------------------------------------
		$("button.expander").on("click", function () {
			if ($(this).attr("aria-expanded") === "false") {
				$(this).attr("aria-expanded", true);
			} else {
				$(this).attr("aria-expanded", false);
			}
		});

		// Navigation
		//---------------------------------------------------------------------------
		initMenu(); // Main navigation
		initMegaMenu(); // Mega Menus
		initTopMenu(); // Top navigation
		initResponsiveMenu(); // Responsive & Mobile navigation

		// Search
		//---------------------------------------------------------------------------
		initSearch(); // Search
		initResponsiveSearch(); // Responsive & Mobile search

		// Show submenu, on click
		//---------------------------------------------------------------------------
		$("button.menu-expand").on("click", function () {
			$(this).toggleClass("is-active");
			$(this).parent("li").children(".submenu").slideToggle(150).toggleClass("is-open");
		});

		// Add classes to header and body on scroll
		//---------------------------------------------------------------------------
		$(window).on("scroll", function () {
			const header = $("#header"),
				body = $("body");

			if ($(this).scrollTop() > 100) {
				header.addClass("scrolled");
				body.addClass("scrolled");
			} else {
				header.removeClass("scrolled");
				body.removeClass("scrolled");
			}
		});

		// Animate content on scroll
		//---------------------------------------------------------------------------
		const scrollAnimate = $(".animate");

		scrollAnimate.each(function () {
			if ($(this).visible(true)) {
				$(this).addClass("vissible");
			}
		});

		$(window).on("scroll", function () {
			scrollAnimate.each(function () {
				if ($(this).visible(true)) {
					$(this).addClass("vissible");
				} else if ($(this).hasClass("animate-once")) {
					return;
				} else {
					$(this).removeClass("vissible");
				}
			});
		});

		function checkMedia() {
			$(document).off("click", 'a[href^="#"]');

			if (window.innerWidth < 1141) {
				$(document).on("click", 'a[href^="#"]', function (event) {
					if (!$(this).hasClass("js-jobylon-show-page")) {
						event.preventDefault();
						$("html, body").animate(
							{
								scrollTop: $($.attr(this, "href")).offset().top - 75,
							},
							500
						);
					}
				});
			} else {
				$(document).on("click", 'a[href^="#"]', function (event) {
					if (!$(this).hasClass("js-jobylon-show-page")) {
						event.preventDefault();
						$("html, body").animate(
							{
								scrollTop: $($.attr(this, "href")).offset().top - 100,
							},
							500
						);
					}
				});
			}
		}

		checkMedia();
		window.addEventListener("resize", checkMedia);

		// Core Block Functions
		//---------------------------------------------------------------------------
		coreCoverStyles();
		coreCoversplitResponsive();

		// Initiate Lightbox functions
		//---------------------------------------------------------------------------
		// initLightbox();

		// AJAX function
		//---------------------------------------------------------------------------
		// $(".ajax-call-button").on("click", function() {
		//  dbyh_ajax_call();
		// });
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};
